/* eslint-disable */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'controlCenter',
    component: () => import(/* webpackChunkName: "controlCenter" */ '../views/control-center/Index.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/Index.vue')
  },
  {
    path: '/rooms',
    name: 'rooms',
    component: () => import(/* webpackChunkName: "rooms" */ '../views/room/Index.vue')
  },
  {
    path: '/rooms/:roomId',
    name: 'stream-room',
    component: () => import(/* webpackChunkName: "room" */ '../views/room/show/Index.vue')
  },
  {
    path: '/session/:token',
    name: 'sessionLink',
    component: () => import(/* webpackChunkName: "sessionLink" */ '../views/session-link/Index.vue')
  },
  {
    path: '/mlink/:organizationName/departments/:categoryCode',
    name: 'categoryMagicLink',
    component: () => import(/* webpackChunkName: "categoryMagicLink" */ '../views/magic-link/Index.vue')
  },
  {
    path: '/mlink/:organizationName/departments/:categoryCode/cammer/:userCode',
    name: 'userMagicLink',
    component: () => import(/* webpackChunkName: "userMagicLink" */ '../views/magic-link/Index.vue')
  },
  {
    path: '/:organizationName/session/:token',
    name: 'organizationSessionLink',
    component: () => import(/* webpackChunkName: "organizationSessionLink" */ '../views/session-link/Index.vue')
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import(/* webpackChunkName: "categories" */ '../views/categories/Index.vue')
  },
  {
    path: '/categories/:name',
    name: 'subCategories',
    component: () => import(/* webpackChunkName: "subCategories" */ '../views/categories/Index.vue')
  },
  {
    path: '/permissions',
    name: 'permissions',
    component: () => import(/* webpackChunkName: "permissions" */ '../views/permissions/Index.vue')
  },
  {
    path: '/lobby',
    name: 'lobby',
    component: () => import(/* webpackChunkName: "lobby" */ '../views/lobby/Index.vue')
  },
  {
    path: '/calling',
    name: 'calling',
    component: () => import(/* webpackChunkName: "calling" */ '../views/calling/Index.vue')
  },
  {
    path: '/room',
    name: 'room',
    component: () => import(/* webpackChunkName: "room" */ '../views/session/Index.vue')
  },
  {
    path: '/call',
    name: 'call',
    component: () => import(/* webpackChunkName: "call" */ '../views/call/Index.vue')
  },
  {
    path: '/queue',
    name: 'queue',
    component: () => import(/* webpackChunkName: "queue" */ '../views/queue/Index.vue')
  },
  {
    path: '/calification',
    name: 'calification',
    component: () => import(/* webpackChunkName: "calification" */ '../views/calification/Index.vue')
  },
  {
    path: '/questions',
    name: 'questions',
    component: () => import(/* webpackChunkName: "Question" */ '../views/questions/Index.vue')
  },
  {
    path: '/thank-you-page',
    name: 'thank-you-page',
    component: () => import(/* webpackChunkName: "thank-you-page" */ '../views/thank-you-page/Index.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '../views/calendar/Index.vue')
  },
  {
    path: '/active-call',
    name: 'active-call',
    component: () => import(/* webpackChunkName: "active-call" */ '../views/session/resources/ActiveCall.vue')
  },
  {
    path: '/attention-types',
    name: 'attention-types',
    component: () => import(/* webpackChunkName: "attention-types" */ '../views/attention-types/Index.vue')
  },
  {
    path: '/validate-email',
    name: 'validate-email',
    component: () => import(/* webpackChunkName: "validate-email" */ '../views/validate-email/Index.vue')
  },
  {
    path: '/totem',
    name: 'totem',
    component: () => import(/* webpackChunkName: "validate-email" */ '../views/totem/Index.vue')
  },
  {
    path: '/totem-on-hold',
    name: 'totemOnHold',
    component: () => import(/* webpackChunkName: "validate-email" */ '../views/totem/OnHold.vue')
  },
  {
    path: '/chat-bot',
    name: 'chatBot',
    component: () => import(/* webpackChunkName: "validate-email" */ '../views/chat/bot/Index.vue')
  },
  {
    path: '/is-busy',
    name: 'isBusy',
    component: () => import(/* webpackChunkName: "is-busy" */ '../views/is-busy/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const pushRoute = (to:any) => {
  const toRoute = {
    name: to.name,
    path: to.path
  }
  Vue.prototype.$widget.history.unshift(toRoute)
}

router.beforeResolve((to, from, next) => {
  if (to.path === '/permissions') {
    const configInitCall = Vue.prototype.$organization.configInitCall()
    const requestAccessToDevices = configInitCall.data?.requestAccessToDevices ?? true

    if (!requestAccessToDevices) {
      next({ name: 'calling' })
      return false
    }
  }

  if (!to.query.back) {
    pushRoute(to)
  }

  next()
})

export default router
